import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import userPhoto from "./user.png"
import me from "./menu-bar.png"
import * as XLSX from 'xlsx';
import axios from 'axios';

const Dashboard = () => {
    const api = process.env.REACT_APP_API
    const mine = process.env.REACT_APP_API_KEY
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [results, setResults] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [loadingMeasurements, setLoadingMeasurements] = useState(false);
    const navigate = useNavigate();
    const [slidingWind, setSlide] = useState("slidingWindow12");

    const toggleSlide = () => {
        setSlide((prevState) =>
            prevState === "slidingWindow12" ? " slidingWindow12 slidingWindow13" : "slidingWindow12"
        );
    };

    const handleLogout = () => {
        axios.post(`${api}/logout`, {}, { withCredentials: true })
            .then(() => {
                localStorage.removeItem('userName');
                alert("Logout successful");
                navigate('/');
            })
            .catch(err => {
                console.error("Error logging out:", err);
                alert("Logout failed. Please try again.");
            });
    };

    // Fetch devices on component mount
    useEffect(() => {
        const fetchDevices = async () => {
            try {
                const response = await fetch(`${api}/api/user/devices`, {
                    credentials: 'include'
                });

                if (response.ok) {
                    const data = await response.json();
                    setDevices(data);
                } else {
                    setError("Failed to fetch devices");
                }
            } catch (err) {
                setError("Something went wrong. Please try again.");
            }
            setLoading(false);
        };

        fetchDevices();
    }, [api]);

    // Fetch measurements for selected device
    const fetchMeasurements = async (device) => {
        setLoadingMeasurements(true);
        setSelectedDevice(device);
        setResults([]);
        
        try {
            console.log("Fetching measurements for device:", device.deviceName);
            
            const response = await fetch(`${mine}/api/measurements/device/${device.deviceName}`, {
                credentials: 'include'
            });
            console.log(response)
            console.log("Response status:", response.status);
            
            if (response.ok) {
                const data = await response.json();
                console.log("Measurements data:", data);
                setResults(data.data || []);
                setError(null);
            } else {
                // Try to get error message from response
                const errorText = await response.text();
                console.log("Error response:", errorText);
                setError(`Failed to fetch measurements: ${response.status}`);
                setResults([]);
            }
        } catch (err) {
            console.error("Error fetching measurements:", err);
            setError("Network error while fetching measurements");
            setResults([]);
        }
        
        setLoadingMeasurements(false);
    };

    const handleDownload = async () => {
        if (!selectedDevice || !results.length) {
            alert("No data to download");
            return;
        }

        try {
            const worksheet = XLSX.utils.json_to_sheet(results);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Measurements');
            XLSX.writeFile(workbook, `${selectedDevice.deviceName}_measurements.xlsx`);
        } catch (error) {
            console.error("Error downloading file:", error);
            alert("Error downloading file.");
        }
    };

    const handleAddDevice = () => {
        navigate('/add-device');
    };

    if (loading) {
        return <div style={{ padding: '20px' }}>Loading devices...</div>;
    }

    return (
        <div className='desh_Outer'>
            <div className={`left_desh2 ${slidingWind}`}>
                <div className='left_desh'>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "100%", alignItems: "center" }}>
                        <img src={userPhoto} style={{ width: "100px", height: "100px", borderRadius: "100%" }} alt="User" />
                        <p style={{ textAlign: 'center', color: "white" }}>
                            {localStorage.getItem('userName')}
                        </p>
                    </div>
                </div>

                <div className='desh_leftContaint'>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <button onClick={handleAddDevice} className="add-device-button">Add Device</button>
                    </div>
                    <div className='listofDevicesName'>List of Devices:</div>
                    <div className='listofdevice'>
                        {devices.map((device) => (
                            <div 
                                key={device._id} 
                                onClick={() => fetchMeasurements(device)}
                                className='device_list_effect'
                                style={{
                                    backgroundColor: selectedDevice?._id === device._id ? '#007bff' : '',
                                    color: selectedDevice?._id === device._id ? 'white' : 'black',
                                    cursor: 'pointer'
                                }}
                            >
                                <div style={{ padding: "8px" }}>
                                    <div>{device.deviceName}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="logout-buttonD">
                    <button onClick={handleLogout} className="logout-button">Logout</button>
                </div>
            </div>

            <div className='backimage' style={{ marginLeft: "10px" }}>
                <div className='dashkeuper'>
                    <div className="dashboard-container">
                        <div className='namePadding' onClick={toggleSlide}>
                            <h2 style={{ margin: "0" }}>Hey! {localStorage.getItem('userName')}</h2>
                        </div>
                        <div className='namePadding2'>
                            <img
                                style={{ width: "30px", height: "30px" }}
                                src={me}
                                onClick={toggleSlide}
                                alt="Menu"
                            />
                        </div>

                        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <h3 style={{ margin: "0" }}>
                                {selectedDevice 
                                    ? `Results for: ${selectedDevice.deviceName}` 
                                    : "Select a device to view measurements"
                                }
                            </h3>
                        </div>

                        {error && (
                            <div style={{ color: 'red', textAlign: 'center', padding: '10px' }}>
                                {error}
                            </div>
                        )}

                        <div className="container">
                            <div className='lets_Fixe_table_col'>
                                <div className='container_Sticky_Box'>Date</div>
                                <div className='container_Sticky_Box'>Optical Rotation</div>
                                <div className='container_Sticky_Box'>ISS</div>
                                <div className='container_Sticky_Box'>Specific Rotation</div>
                                <div className='container_Sticky_Box'>Temperature</div>
                                <div className='container_Sticky_Box'>Cell Length</div>
                            </div>

                            <div className="innercontainer">
                                {loadingMeasurements ? (
                                    <div style={{ padding: "20px", textAlign: "center" }}>
                                        Loading measurements...
                                    </div>
                                ) : results.length > 0 ? (
                                    <>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            {results.map((measurement, index) => (
                                                <div key={index} className='container_Sticky_Box11'>
                                                    {new Date(measurement.timestamp).toLocaleDateString()}
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            {results.map((measurement, index) => (
                                                <div key={index} className='container_Sticky_Box1'>
                                                    {measurement.optical_rotation || 'N/A'}
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            {results.map((measurement, index) => (
                                                <div key={index} className='container_Sticky_Box1'>
                                                    {measurement.iss || 'N/A'}
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            {results.map((measurement, index) => (
                                                <div key={index} className='container_Sticky_Box1'>
                                                    {measurement.specific_rotation || 'N/A'}
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            {results.map((measurement, index) => (
                                                <div key={index} className='container_Sticky_Box1'>
                                                    {measurement.cell_temperature || 'N/A'}°C
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            {results.map((measurement, index) => (
                                                <div key={index} className='container_Sticky_Box1'>
                                                    {measurement.cell_length || 100}mm
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : (
                                    <div style={{ padding: "20px", textAlign: "center" }}>
                                        {selectedDevice ? "No measurements found" : "Select a device"}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div style={{ display: "flex", width: "100%", justifyContent: "center", marginTop: "20px" }}>
                            <button 
                                onClick={handleDownload}
                                className='makeItSticky'
                                disabled={!results.length}
                            >
                                Download Results
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;